import React from 'react';

import { SandboxEmbedCodeSnippetConfig } from './EmbedSandboxCodeSnippetConfig';
import { JSONOptionsSnippet } from './JSONOptionsSnippet';

export const CDNSnippet = (config: SandboxEmbedCodeSnippetConfig) => (
  <>
    {`<div style="width: 100%; height: 100%;" id=`}
    <span className="text-code-c">'embedded-sandbox'</span>
    {`></div>
<script src="https://embeddable-sandbox.cdn.apollographql.com/_latest/embeddable-sandbox.umd.production.min.js"></script> 
<script>
  new window.EmbeddedSandbox(`}
    <JSONOptionsSnippet {...config} />
    {`);
</script>
  `}
  </>
);
